import { render, staticRenderFns } from "./ShortMention.vue?vue&type=template&id=dfc24aaa&scoped=true"
import script from "./ShortMention.vue?vue&type=script&lang=js"
export * from "./ShortMention.vue?vue&type=script&lang=js"
import style0 from "./ShortMention.vue?vue&type=style&index=0&id=dfc24aaa&prod&lang=sass"
import style1 from "./ShortMention.vue?vue&type=style&index=1&id=dfc24aaa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc24aaa",
  null
  
)

export default component.exports